// Modules
import styled from "styled-components";

import { Props } from "./Divider.types";

export const Separator = styled.div<Props>(({ theme }) => ({
  borderBottom: `1px solid ${theme.colors.objectSubtle}`,
  display: "flex",
}));
